const getBackendUrl = () => {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (envUrl) {
    const normalizedUrl = envUrl.replace(/\/+$/, '');

    if (!isLocalhost && normalizedUrl.startsWith('http://')) {
      return normalizedUrl.replace('http://', 'https://');
    }

    return normalizedUrl;
  }

  return isLocalhost ? 'http://localhost:8000' : '';
};

export const BACKEND_URL = getBackendUrl();
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

let wakeUpPromise = null;

export const wakeUpBackend = async () => {
  if (typeof window === 'undefined') return false;

  const lastWakeUp = Number(window.sessionStorage.getItem('backend_last_wakeup_at') || '0');
  const justWokeUp = Date.now() - lastWakeUp < 5 * 60 * 1000;

  if (justWokeUp) {
    return true;
  }

  if (wakeUpPromise) {
    return wakeUpPromise;
  }

  wakeUpPromise = fetch(`${API}/health`, {
    method: 'GET',
    cache: 'no-store',
  })
    .then((response) => {
      if (response.ok) {
        window.sessionStorage.setItem('backend_last_wakeup_at', String(Date.now()));
        return true;
      }
      return false;
    })
    .catch(() => false)
    .finally(() => {
      wakeUpPromise = null;
    });

  return wakeUpPromise;
};

export const getAdminToken = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('admin_token');
};

export const isAdminAuthenticated = () => Boolean(getAdminToken());

export const setAdminSession = ({ access_token, username }) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('admin_auth', 'true');
  localStorage.setItem('admin_token', access_token);
  if (username) {
    localStorage.setItem('admin_username', username);
  }
};

export const clearAdminSession = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('admin_auth');
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_username');
};

export const getAdminAuthHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
